//import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

function NotFound() {
  return (
    <div className="notfound-container">
      <h1 className="notfound-title">404</h1>
      <p className="notfound-message">Oops! The page you are looking for does not exist or you are trying to access the site without logging in.</p>
      <Link to="/" className="notfound-link">
        Go back to Home
      </Link>
    </div>
  );
}

export default NotFound;
